import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const ContentPhoto = ({
  key,
  blockTitle=null,
  blockContent=null,
  mediaPosition="left",
  icon=null,
  photo=null,
}) => {

  const iconUrl = (icon?.formats?.small) ? icon.formats.small.url : icon?.url
  const photoUrl = (photo?.formats?.medium) ? photo.formats.medium.url : photo?.url
  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  return (
    <>
      {photo &&
        <div className="case-study-module case-study-content-with-photo bgg1">
          <div className={ `dot-pattern ${mediaPosition}` }>&nbsp;</div>
          <div className="container">
            <div className="col-12 case-study-content-with-photo-inner">
              <div className="row">
                {mediaPosition === 'left' &&
                  <div className={ `d-none lg-df col-lg-6 img-col case-study-photo ${mediaPosition}` }>
                    <div className="case-study-photo-bg">
                      {photo &&
                        <div className="img-container">
                          <img src={photoUrl.includes(cdnUrl) ? photoUrl : cdnUrl + photoUrl} alt={ photo?.alternativeText } />
                        </div>
                      }
                    </div>
                  </div>
                }
                <div className={ `col-12 col-lg-5 ${mediaPosition === 'left' ? "offset-lg-2" : "offset-lg-1"} case-study-content` }>
                  <div className="row">
                    {icon &&
                      <div className="icon mb1.5">
                        <img src={iconUrl.includes(cdnUrl) ? iconUrl : cdnUrl + iconUrl} alt={ icon?.alternativeText } />
                      </div>
                    }
                    {blockTitle &&
                      <div className="title">
                        <h2 className={ `content-title ${blockContent ? "orange-dash" : ""}` }>{ htmlDecode(blockTitle) }</h2>
                      </div>
                    }
                  </div>
                  <div className="row">
                    {blockContent &&
                      <div className="section-content" dangerouslySetInnerHTML={{ __html: blockContent }} />
                    }
                  </div>
                </div>
                <div className={ `col-12 col-lg-5 offset-lg-1 img-col case-study-photo ${mediaPosition === 'left' ? "lg-dn" : ""} ${mediaPosition}` }>
                  <div className="case-study-photo-bg">
                    {photo &&
                      <div className="img-container">
                        <img src={photoUrl.includes(cdnUrl) ? photoUrl : cdnUrl + photoUrl} alt={ photo?.alternativeText } />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {!photo &&
        <div className="case-study-content-block">
          <div className="container">
            <div className="col-12 col-md-10 offset-md-1 ft6">
              <div className="row">
                {icon &&
                  <div className="df aife icon">
                    <img src={iconUrl.includes(cdnUrl) ? iconUrl : cdnUrl + iconUrl} alt={ icon?.alternativeText } />
                  </div>
                }
                {blockTitle &&
                  <div className="df aife title mb0">
                    <h2 className={ `content-title ${(!icon && blockContent) ? "orange-dash" : ""}` }>{ htmlDecode(blockTitle) }</h2>
                  </div>
                }
                {blockContent &&
                  <div className="content section-content mt1" dangerouslySetInnerHTML={{ __html: blockContent }} />
                }
              </div>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default ContentPhoto
